
import 'whatwg-fetch'
import config from 'react-global-configuration';


const UserActions = {

  create( password, secret, callback){

    const item = {
      password:password,
      secret:secret
    }
    fetch(config.get("API_PATH") + "/users" , {
      method: "POST",
      headers: {
          'Content-Type': 'application/json'
      },
      body: JSON.stringify(item)
    }).then(function(response) {
      if(response.status === 200  ){
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
           return response.json()
         } else {
           return {"error":response.status}
        }
      }else if(response.status === 401){
        return {"error":401}
      }else if(response.status === 403){
        return  {"error":413}
      }else{
        throw new Error('Network response was not ok.');
      }
    }).then(function(data) {
      callback(data)
    })
  },


 
}

export default UserActions
